export const EstateRoute = {
  ANALYTICS: 'analytics',
  ESTATE: { name: 'estate', path: 'estate' },
  ESTATE_SELECTION: 'estate-selection',
  DASHBOARD: 'dashboard',
  OVERVIEW: 'overview',
  PLANNING: 'planning',
  SETTLEMENT: 'settlement',
  SETTINGS: { name: 'estate-settings', path: 'settings' },
  SUMMARY: { name: 'planning-summary', path: 'planning/summary/:id' }
};
